import React from 'react'

const Unauthorized = () => {
    return (
        <div style={{ padding: '20px'}} className='text-center text-muted'>
            You aren't authorized to view this.
        </div>
    )
}

export default Unauthorized